/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/prop-types */
// @ts-nocheck

import { Box } from '@material-ui/core'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import React from 'react'

const TableBodyUI = function (props) {
  const { data, children, headCells, noDataMessage } = props

  if (data?.length) {
    return <TableBody>{children}</TableBody>
  } else {
    return (
      <TableBody>
        <TableRow>
          <TableCell className="no-data" colSpan={headCells.length + 1}>
            <Box
              p={5}
              dispaly="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              width="100%"
            >
              <Box
                component="p"
                fontSize="22px"
                fontWeight="600"
                align="center"
                className="custom-table-no-data"
              >
                {noDataMessage}
              </Box>
            </Box>
          </TableCell>
        </TableRow>
      </TableBody>
    )
  }
}

export default TableBodyUI
